$shm_hitalama_guide $mol_book2
	menu_title \Руководство пользователя
	pages <= guide_pages /$mol_view
	List $shm_list_page
		title \Руководство
		filter? <=> query? \
		add_content /
			<= Add $mol_button_minor
				title \Добавить
				sub /
					<= Add_icon $mol_icon_plus
					\Добавить
				enabled <= editable false
				click? <=> add_toggle? null
			<= Repository_toggle $mol_check_icon
				hint \Репозиторий руководства
				checked? <=> repository_opened? false
				Icon <= Repository_icon $mol_icon_cog
		body /
			^ create_content /$mol_view
			<= Names $shm_hitalama_guide_drag
				catalog <= catalog $shm_hitalama_guide_catalog
				locked <= drag_locked false
				roots <= roots /string
				children* <= children* /string
				expanded*? <=> expanded*? true
				Item* <= Item* $shm_hitalama_guide_item
					catalog <= catalog
					id <= identity* \
					current <= page_current* false
					toggle? <=> group_toggle*? null
	Create $mol_list
		sub /
			<= New_kind $mol_select
				value? <=> new_kind? \page
				dictionary *
					page \Страница
					group \Группа
			<= New_id $mol_string
				hint \ID новой страницы, например maps-widgets
				value? <=> new_id? \
			<= New_title $mol_string
				hint \Название
				value? <=> new_title? \
			<= New_parent $mol_select
				dictionary <= folder_options *
				value? <=> new_parent? \
			<= Create_button $mol_button_major
				title \Создать
				click? <=> add? null
	create_opened? false
	Panel $shm_hitalama_guide_panel
		param \guide_page
		section \knowledge
	Repository $shm_hitalama_guide_repository
		catalog <= catalog $shm_hitalama_guide_catalog
		opened? <=> repository_opened?
		body /
			^
			<= Sections $mol_labeler
				title \Начальные страницы разделов: раздел | ID страницы
				Content <= Sections_input $mol_textarea
					enabled <= editable false
					value? <=> sections_text? \
			<= Save_sections $mol_button_minor
				title \Сохранить начальные страницы
				enabled <= editable false
				click? <=> save_sections? null
